import firebase from 'firebase/app';
import 'firebase/auth';
import isNil from 'lodash/isNil';
import store from '@/store';

// checks if there is a user object in firebase
firebase.auth().onAuthStateChanged(firebaseUser => {
    const actionToDispatch = isNil(firebaseUser) ? 'logout' : 'login';
    store.dispatch(`authentication/${actionToDispatch}`, firebaseUser);
    store.commit('user/SET_CURRENTUSER', firebaseUser, { root: true });
});